import './gauge-square.scss';

interface props {
  title: string | number;
  firstHalfColor: number;
  secondHalfColor: number;
}

const GaugeSquare = ({
  title,
  firstHalfColor: firstColor,
  secondHalfColor: secondColor,
}: props) => {
  const numberToColor = (num: number) => {
    return num === 2 ? '#35e9b9' : num === 1 ? '#ea5455' : '#d8d8d8';
  };
  const getBackground = () => {
    return `linear-gradient(to right,${numberToColor(
      firstColor
    )} 50%, ${numberToColor(secondColor)} 50%)`;
  };
  return (
    <div
      className="gauge-square"
      title={title.toString()}
      style={{ background: getBackground() }}
    />
  );
};

export default GaugeSquare;
